/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Monitoring API
 * Monitoring API for working with device errors
 *
 * The version of the OpenAPI document: 1.20.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    Data,
    ResponseReason,
} from './';

/**
 * Response with list of field names
 * @export
 * @interface ResponseEnumSchema
 */
export interface ResponseEnumSchema {
    /**
     * @type {Data}
     * @memberof ResponseEnumSchema
     */
    data?: Data;
    /**
     * @type {string}
     * @memberof ResponseEnumSchema
     */
    message?: string;
    /**
     * @type {number}
     * @memberof ResponseEnumSchema
     */
    total?: number;
    /**
     * @type {ResponseReason}
     * @memberof ResponseEnumSchema
     */
    reason?: ResponseReason;
}
